import { ReactComponent as Remove } from "../../../../assets/icons/x.svg";

export function GroupTag({ onRemove, selectedGroup }: { onRemove?: () => void, selectedGroup: any }) {
    return (
        <div className="flex items-center gap-2 w-fit rounded-[13px] px-2 py-1" style={{ backgroundColor: selectedGroup?.backgroundColor }}>
            <span className="text-xs" style={{ color: selectedGroup?.textColor }}>{selectedGroup?.name}</span>
            {onRemove && <button type="button" className="group" onClick={onRemove} aria-label={`Remove ${selectedGroup?.name ?? "cohort"}`}>
                <Remove className="[&_path]:stroke-gray-701 group-hover:opacity-80 w-3 h-3" />
            </button>}
        </div>
    )
}